// DashboardTitle.jsx

import React, { useMemo } from 'react';

// Device Detection
import { useIsMobile } from 'hooks/useDeviceDetect';

// CSS
import './DashboardTitle.css';

/**
 * NodeTitle
 * 
 * Displays the title input for a dashboard.
 * 
 * @param {object} dashboard - Dashboard object.
 * @param {Function} onTitleSaved - Callback when title is saved.
 *  
 *
 * @returns {ReactNode} - NodeTitle component.
 */
const DashboardTitle = ({ dashboard }) => {

    // ----- DEVICE DETECTION ----- //

    const isMobile = useIsMobile();

    // ----- MEMOS ----- //

    // Title state

    const computedTitle = useMemo(() => {
        return String(dashboard?.title || '').trim();
    }, [dashboard?.title]);

    const computedDescription = useMemo(() => {
        return String(dashboard?.description || '').trim();
    }, [dashboard?.description]);

    // ----- RENDER ----- //

    return (
        <div className="dashboard-title-container">

            {/* TITLE */}
            {computedTitle && (

                <div
                  className="dashboard-title-title"
                  style={{
                    fontSize: isMobile ? 22 : 28,
                  }}
                >
                    {computedTitle}
                </div>
            )}

            {/* DESCRIPTION */}
            {computedDescription && (
                <div
                  className="dashboard-title-description"
                >
                    {computedDescription}
                </div>
            )}

        </div>
    );
};

// Dev Tools
DashboardTitle.displayName = 'DashboardTitle';

export default DashboardTitle;
